/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "मैया",
      "0": "दिनै",
      "1": "गाबोन",
      "future": {
        "one": "{0} सानाव",
        "other": "{0} सानाव"
      },
      "past": {
        "one": "{0} सान सिगां",
        "other": "{0} सान सिगां"
      }
    },
    "day-narrow": {
      "-1": "मैया",
      "0": "दिनै",
      "1": "गाबोन",
      "future": {
        "one": "{0} सानाव",
        "other": "{0} सानाव"
      },
      "past": {
        "one": "{0} सान सिगां",
        "other": "{0} सान सिगां"
      }
    },
    "day-short": {
      "-1": "मैया",
      "0": "दिनै",
      "1": "गाबोन",
      "future": {
        "one": "{0} सानाव",
        "other": "{0} सानाव"
      },
      "past": {
        "one": "{0} सान सिगां",
        "other": "{0} सान सिगां"
      }
    },
    "hour": {
      "0": "बे घन्टा",
      "future": {
        "one": "{0} घन्टायाव",
        "other": "{0} घन्टायाव"
      },
      "past": {
        "one": "{0} घन्टा सिगां",
        "other": "{0} घन्टा सिगां"
      }
    },
    "hour-narrow": {
      "0": "बे घन्टा",
      "future": {
        "one": "{0} घन्टायाव",
        "other": "{0} घन्टायाव"
      },
      "past": {
        "one": "{0} घन्टा सिगां",
        "other": "{0} घन्टा सिगां"
      }
    },
    "hour-short": {
      "0": "बे घन्टा",
      "future": {
        "one": "{0} घन्टायाव",
        "other": "{0} घन्टायाव"
      },
      "past": {
        "one": "{0} घन्टा सिगां",
        "other": "{0} घन्टा सिगां"
      }
    },
    "minute": {
      "0": "बे मिनिट",
      "future": {
        "one": "{0} मिनिटआव",
        "other": "{0} मिनिटआव"
      },
      "past": {
        "one": "{0} मिनिट सिगां",
        "other": "{0} मिनिट सिगां"
      }
    },
    "minute-narrow": {
      "0": "बे मिनिट",
      "future": {
        "one": "{0} मिनिटआव",
        "other": "{0} मिनिटआव"
      },
      "past": {
        "one": "{0} मिनिट सिगां",
        "other": "{0} मिनिट सिगां"
      }
    },
    "minute-short": {
      "0": "बे मिनिट",
      "future": {
        "one": "{0} मिनिटआव",
        "other": "{0} मिनिटआव"
      },
      "past": {
        "one": "{0} मिनिट सिगां",
        "other": "{0} मिनिट सिगां"
      }
    },
    "month": {
      "-1": "थांनाय दान",
      "0": "बे दान",
      "1": "फैगौ दान",
      "future": {
        "one": "{0} दानाव",
        "other": "{0} दानाव"
      },
      "past": {
        "one": "{0} दान सिगां",
        "other": "{0} दान सिगां"
      }
    },
    "month-narrow": {
      "-1": "थांनाय दान",
      "0": "बे दान",
      "1": "फैगौ दान",
      "future": {
        "one": "{0} दानाव",
        "other": "{0} दानाव"
      },
      "past": {
        "one": "{0} दान सिगां",
        "other": "{0} दान सिगां"
      }
    },
    "month-short": {
      "-1": "थांनाय दान",
      "0": "बे दान",
      "1": "फैगौ दान",
      "future": {
        "one": "{0} दानाव",
        "other": "{0} दानाव"
      },
      "past": {
        "one": "{0} दान सिगां",
        "other": "{0} दान सिगां"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "थांनाय खोन्दोसे",
      "0": "बे खोन्दोसे",
      "1": "फैगौ खोन्दोसे",
      "future": {
        "one": "{0} खोन्दोसेआव",
        "other": "{0} खोन्दोसेआव"
      },
      "past": {
        "one": "{0} खोन्दोसे सिगां",
        "other": "{0} खोन्दोसे सिगां"
      }
    },
    "quarter-narrow": {
      "-1": "थांनाय खोन्दोसे",
      "0": "बे खोन्दोसे",
      "1": "फैगौ खोन्दोसे",
      "future": {
        "one": "{0} खोन्दोसेआव",
        "other": "{0} खोन्दोसेआव"
      },
      "past": {
        "one": "{0} खोन्दोसे सिगां",
        "other": "{0} खोन्दोसे सिगां"
      }
    },
    "quarter-short": {
      "-1": "थांनाय खोन्दोसे",
      "0": "बे खोन्दोसे",
      "1": "फैगौ खोन्दोसे",
      "future": {
        "one": "{0} खोन्दोसेआव",
        "other": "{0} खोन्दोसेआव"
      },
      "past": {
        "one": "{0} खोन्दोसे सिगां",
        "other": "{0} खोन्दोसे सिगां"
      }
    },
    "second": {
      "0": "दा",
      "future": {
        "one": "{0} सेकेण्डआव",
        "other": "{0} सेकेण्डआव"
      },
      "past": {
        "one": "{0} सेकेण्ड सिगां",
        "other": "{0} सेकेण्ड सिगां"
      }
    },
    "second-narrow": {
      "0": "दा",
      "future": {
        "one": "{0} सेकेण्डआव",
        "other": "{0} सेकेण्डआव"
      },
      "past": {
        "one": "{0} सेकेण्ड सिगां",
        "other": "{0} सेकेण्ड सिगां"
      }
    },
    "second-short": {
      "0": "दा",
      "future": {
        "one": "{0} सेकेण्डआव",
        "other": "{0} सेकेण्डआव"
      },
      "past": {
        "one": "{0} सेकेण्ड सिगां",
        "other": "{0} सेकेण्ड सिगां"
      }
    },
    "week": {
      "-1": "थांनाय सप्थाह",
      "0": "बे सप्थाह",
      "1": "फैगौ सप्थाह",
      "future": {
        "one": "{0} सप्थाहयाव",
        "other": "{0} सप्थाहयाव"
      },
      "past": {
        "one": "{0} सप्थाह सिगां",
        "other": "{0} सप्थाह सिगां"
      }
    },
    "week-narrow": {
      "-1": "थांनाय सप्थाह",
      "0": "बे सप्थाह",
      "1": "फैगौ सप्थाह",
      "future": {
        "one": "{0} सप्थाहयाव",
        "other": "{0} सप्थाहयाव"
      },
      "past": {
        "one": "{0} सप्थाह सिगां",
        "other": "{0} सप्थाह सिगां"
      }
    },
    "week-short": {
      "-1": "थांनाय सप्थाह",
      "0": "बे सप्थाह",
      "1": "फैगौ सप्थाह",
      "future": {
        "one": "{0} सप्थाहयाव",
        "other": "{0} सप्थाहयाव"
      },
      "past": {
        "one": "{0} सप्थाह सिगां",
        "other": "{0} सप्थाह सिगां"
      }
    },
    "year": {
      "-1": "थांनाय बोसोर",
      "0": "बे बोसोर",
      "1": "फैगौ बोसोर",
      "future": {
        "one": "{0} बोसोरआव",
        "other": "{0} बोसोरआव"
      },
      "past": {
        "one": "{0} बोसोर सिगां",
        "other": "{0} बोसोर सिगां"
      }
    },
    "year-narrow": {
      "-1": "थांनाय बोसोर",
      "0": "बे बोसोर",
      "1": "फैगौ बोसोर",
      "future": {
        "one": "{0} बोसोरआव",
        "other": "{0} बोसोरआव"
      },
      "past": {
        "one": "{0} बोसोर सिगां",
        "other": "{0} बोसोर सिगां"
      }
    },
    "year-short": {
      "-1": "थांनाय बोसोर",
      "0": "बे बोसोर",
      "1": "फैगौ बोसोर",
      "future": {
        "one": "{0} बोसोरआव",
        "other": "{0} बोसोरआव"
      },
      "past": {
        "one": "{0} बोसोर सिगां",
        "other": "{0} बोसोर सिगां"
      }
    }
  },
  "locale": "brx"
})
}
